/** RevenueCat entitlement that unlocks TaskScribe Pro. */
export const TASKSCRIBE_PRO_ENTITLEMENT = "TaskScribe Pro";

/** Current offering lookup key in the RevenueCat dashboard. */
export const TASKSCRIBE_DEFAULT_OFFERING = "default";

/** Store product identifier for the US$1.99/month Pro plan. */
export const TASKSCRIBE_MONTHLY_PRODUCT_ID = "taskscribe_pro_monthly";
